import { render, staticRenderFns } from "./MagicButton.vue?vue&type=template&id=458fa8a5&"
import script from "./MagicButton.vue?vue&type=script&lang=js&"
export * from "./MagicButton.vue?vue&type=script&lang=js&"
import style0 from "./MagicButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports